
import { mapGetters } from "vuex";
import appConfig from "../../appconfig";
import * as Util from "../../libraries/utils";
import ProductProvider from "../../providers/ProductProvider";
import VoucherCartDialogGt2 from "../../components/ShopComponents/gt2/Dialogs/VoucherCartDialog-gt2.vue";
import VoucherLandingPageDialogGt2 from "../../components/ShopComponents/gt2/Dialogs/VoucherLandingPageDialog-gt2.vue";
import VoucherCatalogDialogGt3 from "../../components/ShopComponents/gt3/Dialogs/VoucherCatalogDialog-gt3.vue";
import {hasVoucherReachedLimitOnThisDevice} from "../../helper/VoucherValidationHelper";

const TimeBox = appConfig.timeBoxImpl.timebox;
const TimeBoxFormats = appConfig.timeBoxImpl.Formats;

export default {
	data() {
		return {
			awardDialog: {
				show: false,
				onClose: () => this.awardDialog.show = false
			},
			availableVouchersData: [],
			product: null,
			awardVoucherItem: null,
			snackbar: {
				msgToAppear: "",
				isActive: false
			}
		};
	},
	components: {VoucherCartDialogGt2, VoucherLandingPageDialogGt2, VoucherCatalogDialogGt3},
	computed: {
		...mapGetters(["applicationUserLoggedIn", "userCrmVouchers", "userCrmVouchersAndMilestoneRewards"]),
		isAtLeastOneDiscountAppliedToCartSelection() {
			const ids = this.availableVouchersData.map(x=>x.voucherId);
			const psWithVouchers = this.cartProducts.filter(x=>x.voucherId);
			return psWithVouchers.find(x => ids.includes(x.voucherId));
		}
	},
	methods: {
		getProductImage(product) {
			return Util.getBackImages(product).slice(0, 1);
		},
		getVouchersData() {
			const self = this;
			if(!self.$store.getters.featureToggles.enableDiscountsPage || !self.applicationUserLoggedIn) {
				return [];
			}
			if (self.availableVouchersData.length) {
				return self.availableVouchersData;
			}
			self.availableVouchersData.push(...self.getAvailableVouchers());
			return self.availableVouchersData;
		},
		// called on landingpage-gt2
		async showAwardDialogIfThereAreNewVouchers() {
			const self = this;
			self.awardVoucherItem = self.getVouchersData().find(x => x.options.award && !self.userCrmVouchers.includes(x.id) && !x.usedAt);
			if(self.awardVoucherItem) {
				const products = await ProductProvider.getProducts({productIds: self.awardVoucherItem.productPattern});
				if(products && products.length > 0) {
					self.product = products[0];
				}
				self.awardDialog.show = true;
				self.$store.commit("SET_USER_CRM_USED_VOUCHERS", self.userCrmVouchers.concat(self.awardVoucherItem.id));
			}
		},
		getDialogData() {
			const self = this;
			return {
				show: self.awardDialog.show,
				onClose: self.awardDialog.onClose,
				vouchersData: self.availableVouchersData,
				product: self.product,
				awardVoucherItem: self.awardVoucherItem,
				getProductImage: self.getProductImage
			};
		},


		// gt3 product catalog part
		async showAwardDialogIfThereAreNewVouchersGt3({voucherIds = []}) {
			const self = this;
			self.awardVoucherItem = (await self.getVouchersData()).find(x => x.options.award && !self.userCrmVouchers.includes(x.id) && !x.usedAt && !voucherIds.includes(x.voucherId));
			if(this.awardVoucherItem) {
				self.product = self.$store.getters.productCatalog.getProduct(this.awardVoucherItem.productPattern[0]);
				const isProductAvailable = Util.canBePickedUp(
					self.product,
					self.$store.getters.productCatalog,
					self.cachedPickupRules,
					self.globalSelectedShop.id
				);
				if(isProductAvailable) {
					self.awardDialog.show = true;
					self.$store.commit("SET_USER_CRM_USED_VOUCHERS", self.userCrmVouchers.concat(self.awardVoucherItem.id));
				}
			}
		},

		getAvailableVouchers() {
			const self = this;
			const vouchersData = self.userCrmVouchersAndMilestoneRewards;
			const filterProductsWhichAreNotInProductCatalog = (item) => {
				if (!self.$store.getters.productCatalog) {
					return true;
				}
				const productId = ((vouchersData.find(x => x.productPattern && x.productPattern[0] === item.productPattern[0]) || {}).productPattern || [])[0];
				return productId ? self.$store.getters.productCatalog.productMap[productId] : false;
			};
			const isUsageAllowed = (item) => {
				if (item.maxNumberOfUsages) {
					if (item.maxNumberOfUsages <= item.usageCounter) {
						return false;
					}
				}
				return true;
			};
			const isExpired = (item) => {
				if (!item.expiryDate) {
					return false;
				}
				const f = TimeBoxFormats.YYYY_MM_DD;
				return TimeBox.fromISO(item.expiryDate).format(f).exec() < TimeBox.now().format(f).exec();
			};
			const filterValidVouchers = (vouchersData) => {
				const results = vouchersData.map((voucher) => {
					const voucherReachedLimitOnThisDevice = hasVoucherReachedLimitOnThisDevice(voucher.priceRuleId);
					return {
						voucher: voucher,
						allowed:
							isUsageAllowed(voucher) &&
							!isExpired(voucher) &&
							!voucherReachedLimitOnThisDevice &&
							!!filterProductsWhichAreNotInProductCatalog(voucher)
					};
				});

				return results
					.filter(r => r.allowed)
					.map(r => r.voucher);
			};
			return filterValidVouchers(vouchersData);
		},
		handleVoucherAction(input) {
			this.snackbar.msgToAppear = input.msgToAppear;
			this.snackbar.isActive = input.isActive;
		}
	}
};
